<template>
  <div>
    <v-card :class="totop" :loading="loading" flat class="max-height">
      <div class="float-left width-full">
        <div class="width-full">
          <div class="chart-title float-left">
            <v-icon>speaker_notes</v-icon>
            {{names[parentType]}} Description
          </div>
          <div v-if="editable" class="settings-button">
            <v-btn icon class="my-0" @click="edit ? edit = false : edit = true">
              <v-icon size="18" color="#808F9C">edit</v-icon>
            </v-btn>
          </div>
        </div>

        <v-card-text class="pa-4 width-full float-left font-small" v-if="!edit">{{value}}</v-card-text>

        <div v-if="edit" class="width-full float-left pa-4 font-small">
          <v-textarea
            v-on:keyup.enter="updateDescription"
            v-model="newDesc"
            counter
            ref="description"
            maxlength="1024"
            color="#4dbac0"
            rows="10"
          ></v-textarea>
          <v-card-actions>
            <v-btn @click="edit = false" text>Cancel</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="updateDescription" text>SAVE</v-btn>
          </v-card-actions>
        </div>
      </div>
    </v-card>
    <div :class="dimmer" @click="edit = false"></div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "Description",
  props: { value: String, parentType: String, storeKey: String, editable: Boolean },
  data() {
    return {
      loading: false,
      edit: false,
      totop: "totop-off",
      dimmer: "dimmer-off",
      newDesc: this.value,
      type: "",
      names: { Strategies: "Strategy", Tags: "Tag" }
    };
  },
  watch: {
    edit: function(newVal) {
      if (newVal === true) {
        this.newDesc  = this.value
        this.totop = "totop";
        this.dimmer = "dimmer";
      } else {
        this.totop = "totop-off";
        this.dimmer = "dimmer-off";
      }
    }
  },
  methods: {
    updateDescription() {
      axios
        .post("https://tradeinpool.com:3001/api/update/"+this.parentType, {
          documentId: this.$route.params.id,
          key: "description",
          newValue: this.newDesc
        })
        .then(response => {
          this.loading = false;
          this.edit = false;
          this.$emit('update', {new: this.newDesc, response: response.data.push[0].value})
        })
        .catch(err => {
          alert(err);
          this.loading = false;
        });
    }
  }
};
</script>

<style>
</style>